import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { BundleEventData, EventDataBase, LoanEventData, NavigationEventData } from './events/event-data.type';
import { eventMapper } from './events/event-manager.class';
import { WorkflowWidgetEventNames } from './events/events.enums';
import { WorkflowWidgetEvent } from './events/workflow-widget-event.type';

@Injectable({ providedIn: 'root' })
export class WorkflowWidgetEventServiceService {
  private static workflowEvents = new Subject<WorkflowWidgetEvent>();

  public get workflowEvents$(): Observable<WorkflowWidgetEvent> {
    return WorkflowWidgetEventServiceService.workflowEvents.asObservable();
  }

  constructor() {}

  public emitApplicationSubmit(data: LoanEventData): void {
    this.emit(WorkflowWidgetEventNames.ApplicationSubmit, data);
  }

  public emitLoanCreated(data: LoanEventData): void {
    this.emit(WorkflowWidgetEventNames.LoanCreated, data);
  }

  public emitBundleCreated(data: BundleEventData): void {
    this.emit(WorkflowWidgetEventNames.BundleCreated, data);
  }

  public emitBundleLoaded(data: BundleEventData): void {
    this.emit(WorkflowWidgetEventNames.BundleLoaded, data);
  }

  public emitNextButtonClicked(data: NavigationEventData): void {
    this.emit(WorkflowWidgetEventNames.NextButtonClicked, data);
  }

  public emitPreviousButtonClickedClicked(data: NavigationEventData): void {
    this.emit(WorkflowWidgetEventNames.PreviousButtonClicked, data);
  }

  public emit(name: WorkflowWidgetEventNames, data: EventDataBase): void {
    data.eventName = name;
    data.eventDataType = eventMapper.getEventDataType(name);
    WorkflowWidgetEventServiceService.workflowEvents.next({ name, data });
  }
}
